<template>
  <v-card flat>
    <UserInfoCard />

    <SignatureModeSummaryCard class="mt-4" />
    <InviteesSummaryCard class="mt-6" />

    <div class="mt-3 mb-4">
      <PlaceSignaturesSwitch />
      <v-expand-transition class="mb-3">
        <div
          v-if="globalStore?.pageCount > 1 && globalStore.pdfPreviewRendered"
          v-show="createStore.placeSignaturesModel"
          class="mt-n2"
        >
          <MoveSignaturesMenu />
        </div>
      </v-expand-transition>
    </div>

    <SigningWorkflowDialog />
  </v-card>
</template>

<script setup lang="ts">
import UserInfoCard from '@/components/create/UserInfoCard.vue';
import SignatureModeSummaryCard from '@/components/create/SignatureModeSummaryCard.vue';
import InviteesSummaryCard from '@/components/create/InviteesSummaryCard.vue';
import PlaceSignaturesSwitch from '@/components/create/settings/PlaceSignaturesSwitch.vue';
import MoveSignaturesMenu from '@/components/menus/MoveSignaturesMenu.vue';
import SigningWorkflowDialog from '@/components/dialogs/signing-workflow/SigningWorkflowDialog.vue';
import { useCreateStore } from '@/stores/create';
import { useGlobalStore } from '@/stores/global';

const createStore = useCreateStore();
const globalStore = useGlobalStore();
</script>
